export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Profile.json?hash=3b3eff88bef3110cde615709bd203305";